import { Component, PropTypes } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import Message from 'components/Message';
import cx from 'classnames';
import { handleShare, toggleStaticFooter } from 'utils';
import { messagesBySection, messageSections } from 'config';
import styles from './styles.css';

export default class MessageList extends Component {
	static propTypes = {
		sectionIndex: PropTypes.number.isRequired,
		hasAside: PropTypes.bool.isRequired,
		onMessageBodyClick: PropTypes.func.isRequired,
		onMessageImageClick: PropTypes.func.isRequired,
		onSectionChange: PropTypes.func.isRequired
	}

	constructor(props) {
		super(props);

		this.state = {
			messages: [],
			hasMoreMessages: true
		};

		this.sectionMessages = messagesBySection[this.props.sectionIndex];
		this.nextSection = messageSections[this.props.sectionIndex + 1];
	}

	getNextMessage() {
		const messages = this.sectionMessages.slice(0, this.state.messages.length + 1);
		const hasMoreMessages = messages.length !== this.sectionMessages.length;

		this.setState({messages, hasMoreMessages});

		toggleStaticFooter(!hasMoreMessages);
	}

	isImageClickable(message) {
		return !message.aside &&
			!/\.gif$/.test(message.image);
	}

	isMultiMessageCheck() {
		let lastName;

		return ({ name }) => {
			const isMultiMessage = name === lastName;
			lastName = name;
			return isMultiMessage;
		};
	}

	renderPrompts() {
		return (
			<div className={styles.prompts}>
				<div className={styles.prompt} onClick={() => handleShare('facebook')}><span className={cx(styles.icon, styles.facebook)} /></div>
				<div className={styles.prompt} onClick={() => handleShare('twitter')}><span className={cx(styles.icon, styles.twitter)} /></div>

				{this.nextSection &&
					<div className={cx(styles.prompt, styles.next)} onClick={() => this.props.onSectionChange(this.props.sectionIndex + 1)}>
						Next part: {this.nextSection.title}
					</div>}
			</div>
		);
	}

	render() {
		const isMultiMessage = this.isMultiMessageCheck();

		const className = cx(styles.messageList, {
			[styles.hasAside]: this.props.hasAside,
			[styles.hasMoreMessages]: this.state.hasMoreMessages
		});

		return (
			<div className={className}>
				{this.state.messages.map((message, index) =>
					<Message key={index}
						message={message}
						isMultiMessage={isMultiMessage(message)}
						onClick={() => message.aside && this.props.onMessageBodyClick(message.aside)}
						onImageClick={this.isImageClickable(message) && (() => this.props.onMessageImageClick({image: message.image}))} />
				)}

				{!this.state.hasMoreMessages
					&& this.renderPrompts()}

				<div className={styles.bottomSensor}>
					<VisibilitySensor active={this.state.hasMoreMessages}
						onChange={(isVisible) => isVisible && this.getNextMessage()}
						delay={200} />
				</div>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./components/MessageList/index.js
 **/